import mapGeneralProduct, { RawProduct as RawGeneralProduct } from '~/Api/Product/mapProduct';

import mapReferencePrice, { RawReferencePrice } from './mapReferencePrice';
import Product from './Product';

export interface RawProduct {
	product: RawGeneralProduct;
	dosageStrengthForCalculation: number | null;
	packageSizeForCalculation: number | null;
	packageSizeForSingleUnit: number | null;
	singleUnitPackageSize: boolean;
	referencePrices: RawReferencePrice[];
	selectable: boolean;
	selected: boolean;
	referenceDataSource: boolean;
}

export default function mapProduct(product: RawProduct): Product {
	return new Product(
		mapGeneralProduct(product.product),
		product.dosageStrengthForCalculation,
		product.packageSizeForCalculation,
		product.packageSizeForSingleUnit,
		product.singleUnitPackageSize,
		product.referencePrices.map(mapReferencePrice),
		product.selectable,
		product.selected,
		product.referenceDataSource
	);
}
